import Vue from "vue";
import Vuex from "vuex";
// import { required, minLength, between } from "vuelidate/lib/validators";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    about_page: {
      sections: [
        {
          id: "about",
          text:
            "<h1 class='title'>Hi! I'm Sara.</h1><br/><h2 class='subtitle'>I am a graphic designer and front-end web developer based in Brooklyn, NY. I have several years of experience both working full-time at agencies as well as freelancing. A PDF portfolio and CV are available upon request.</h2>",
          image: ""
        }
      ]
    },
    work_page: {
      projects: [
        {
          id: 0,
          text: "WE ARE UNICORN",
          url: "we-are-unicorn",
          tags: ["all", "design"],
          subheader: "Campaign Event Branding",
          type: "student",
          description:
            "Developed branding for a campaign encouraging developers and designers to collaborate and expand their skillsets across the boundary between the fields.",
          numImages: 5,
          classes: "is-6 is-shady"
        },
        {
          id: 1,
          text: "NOUVEAU FRISSONS",
          url: "nouveau-frissons",
          tags: ["all", "design"],
          subheader: "Music Festival Branding",
          type: "student",
          description:
            "Developed the visual identity for a music festival in Portmerion. Focused on the use of illusions and complexity along with vibrant colors to invoke curiosity.",
          numImages: 4,
          classes: "is-6 is-shady"
        },
        {
          id: 2,
          text: "SLY FOX",
          url: "sly-fox",
          tags: ["all", "design"],
          subheader: "Startup Identity Branding",
          type: "student",
          description:
            "Developed a slick, quirky and fun identity for an online shaving kit sold directly to consumers through its website and a reputable LA barbershop.",
          numImages: 6,
          classes: "is-6 is-shady"
        },
        {
          id: 3,
          text: "KID A",
          url: "kid-a",
          tags: ["all", "design"],
          subheader: "Handmade Album Design",
          type: "student",
          description:
            "Redesigned the cover for the Radiohead album titled Kid A. Utilized the technique of anamorphosis to create the letterforms out of separate pieces of wood.",
          numImages: 4,
          classes: "is-6 is-shady"
        },
        {
          id: 4,
          text: "PLATFORM X",
          url: "platform-x",
          tags: ["all", "development"],
          subheader: "Microsite Development",
          type: "client",
          description:
            "Utilized Vue.js to develop a microsite for Furthermore of Equinox. Website design provided by Furthermore.",
          link: "https://furthermore.equinox.com/platformx#/",
          numImages: 2,
          classes: "is-6 is-shady"
        },
        // {
        //   id: 4,
        //   text: "CONDITIONAL FORM",
        //   url: "conditional-form",
        //   tags: ["all", "development"],
        //   subheader: "Conditional Form Development",
        //   type: "client",
        //   description: "awef wef wef wf wef wefwe fawefawe fpawef",
        //   link: "https://github.com/sara-huser",
        //   classes: "is-6 is-shady",
          // form: {
          //   status: "",
          //   fields: [
          //     {
          //       id: 0,
          //       label: "Parent Form",
          //       value: "PARENT",
          //       fields: [
          //         {
          //           label: "First Name",
          //           value: "",
          //           columnsClass: "is-half",
          //           pattern: "SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS",
          //           validators: {
          //             required: true
          //           }
          //         },
          //         {
          //           label: "Last Name",
          //           value: "",
          //           columnsClass: "is-half",
          //           pattern: "SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS",
          //           validators: {
          //             required: true
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       id: 1,
          //       label: "Address",
          //       value: "ADDRESS",
          //       fields: [
          //         {
          //           label: "Street",
          //           value: "",
          //           columnsClass: "is-one-third",
          //           isAddress: true,
          //           allowAutocomplete: true,
          //           autocompleteActive: false,
          //           validators: {
          //             required: true
          //           }
          //         },
          //         {
          //           label: "City",
          //           value: "",
          //           columnsClass: "is-one-third",
          //           isAddress: true,
          //           allowAutocomplete: true,
          //           autocompleteActive: false,
          //           validators: {
          //             required: true
          //           }
          //         },
          //         {
          //           label: "State",
          //           value: "",
          //           columnsClass: "is-2",
          //           pattern: "AA",
          //           isAddress: true,
          //           allowAutocomplete: true,
          //           autocompleteActive: false,
          //           validators: {
          //             required: true,
          //             minLength: 2
          //           }
          //         },
          //         {
          //           label: "Zip",
          //           value: "",
          //           columnsClass: "is-2",
          //           pattern: "#####",
          //           isAddress: true,
          //           validators: {
          //             required: true,
          //             minLength: 5
          //           }
          //         },
          //         {
          //           label: "Home Phone",
          //           value: "",
          //           columnsClass: "is-one-third",
          //           pattern: "(###) ###-####",
          //           validators: {}
          //         },
          //         {
          //           label: "Cell Phone",
          //           value: "",
          //           columnsClass: "is-one-third",
          //           pattern: "(###) ###-####",
          //           validators: {
          //             required: true
          //           }
          //         },
          //         {
          //           label: "Email",
          //           value: "",
          //           columnsClass: "is-one-third",
          //           validators: {
          //             required: true,
          //             email: true
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       id: 22,
          //       label: "Guardian Form",
          //       value: "GUARDIAN",
          //       fields: [
          //         {
          //           label: "Will there be another caregiver coming to class?",
          //           value: "",
          //           columnsClass: "is-half",
          //           inputType: "select",
          //           inputOptions: ["Yes", "No", "Not sure"],
          //           validators: {
          //             required: true
          //           }
          //         },
          //         {
          //           hide: true,
          //           label: "First Name",
          //           value: "",
          //           columnsClass: "is-half",
          //           pattern: "SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS",
          //           validators: {}
          //         },
          //         {
          //           hide: true,
          //           label: "Last Name",
          //           value: "",
          //           columnsClass: "is-half",
          //           pattern: "SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS",
          //           validators: {}
          //         },
          //         {
          //           hide: true,
          //           label: "Relationship",
          //           value: "",
          //           columnsClass: "is-half",
          //           pattern: "SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS",
          //           validators: {}
          //         },
          //         {
          //           hide: true,
          //           label: "Cell Phone",
          //           value: "",
          //           columnsClass: "is-one-third",
          //           pattern: "(###) ###-####",
          //           validators: {}
          //         }
          //       ]
          //     },
          //     {
          //       id: 2,
          //       label: "Child Form",
          //       value: "CHILD",
          //       fields: [
          //         {
          //           label: "First Name",
          //           value: "",
          //           columnsClass: "is-half",
          //           pattern: "SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS",
          //           validators: {
          //             required: true
          //           }
          //         },
          //         {
          //           label: "Last Name",
          //           value: "",
          //           columnsClass: "is-half",
          //           pattern: "SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS",
          //           validators: {
          //             required: true
          //           }
          //         },
          //         {
          //           label: "Birthday",
          //           value: "",
          //           columnsClass: "is-half",
          //           placeholder: "mm/dd/yyyy",
          //           pattern: "##/##/####",
          //           isDate: true,
          //           validators: {
          //             required: true
          //           }
          //         },
          //         {
          //           label: "Gender",
          //           value: "",
          //           columnsClass: "is-half",
          //           inputType: "select",
          //           inputOptions: [
          //             "Female",
          //             "Male",
          //             "Other",
          //             "Prefer not to say"
          //           ],
          //           validators: {
          //             required: true
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       id: 3,
          //       label: "Program Form",
          //       value: "PROGRAM",
          //       columnsClass: "is-one-third",
          //       fields: [
          //         {
          //           label: "Program",
          //           value: "",
          //           inputType: "conditional-select",
          //           inputOptions: [
          //             {
          //               label: "Art",
          //               classOptions: [
          //                 {
          //                   label: "Art Beginnings (1.5y-3y)",
          //                   dayOptions: [
          //                     { label: "Thursday - 9:45" },
          //                     { label: "Thursday - 10:30" },
          //                     { label: "Friday - 9:45" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Art Discovery 1 (3y-5y)",
          //                   dayOptions: [
          //                     { label: "Wednesday - 5:30" },
          //                     { label: "Friday - 10:30" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Art Discovery 2 (5y-8y)",
          //                   dayOptions: [
          //                     { label: "Monday - 4:00" },
          //                     { label: "Saturday - 10:15" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Art Discovery 3 (8y-11y)",
          //                   dayOptions: [
          //                     { label: "Monday - 5:00" },
          //                     { label: "Saturday - 11:15" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Art Evolution 1 (11y-13y)",
          //                   dayOptions: [{ label: "Monday - 6:15" }]
          //                 }
          //               ]
          //             },
          //             {
          //               label: "Dance",
          //               classOptions: [
          //                 {
          //                   label: "Pre-Ballet Leap N Learn 3 (3y)",
          //                   dayOptions: [
          //                     { label: "Monday - 10:15 AM" },
          //                     { label: "Wednesday - 3:30 PM" },
          //                     { label: "Thursday - 6:15 PM" },
          //                     { label: "Friday - 9:30 AM" },
          //                     { label: "Saturday - 9:15 AM" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Pre-Ballet Leap N Learn 4 (4y)",
          //                   dayOptions: [
          //                     { label: "Monday - 2:00 PM" },
          //                     { label: "Wednesday - 4:30 PM" },
          //                     { label: "Thursday - 5:15 PM" },
          //                     { label: "Saturday - 10:15 AM" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Pre-Ballet Leap N Learn 5 (5y)",
          //                   dayOptions: [
          //                     { label: "Tuesday - 4:15 PM" },
          //                     { label: "Saturday - 11:15 AM" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Pre-Ballet Leap N Learn 6 (6y)",
          //                   dayOptions: [{ label: "Saturday - 12:15 PM" }]
          //                 },
          //                 {
          //                   label: "Pre Hip Hop 1 (4.5y-8y)",
          //                   dayOptions: [{ label: "Wednesday - 4:30 PM" }]
          //                 },
          //                 {
          //                   label: "Pre Hip Hop 2 (7y-10y)",
          //                   dayOptions: [{ label: "Wednesday - 5:30 PM" }]
          //                 },
          //                 {
          //                   label: "Jazz 1 (8y-10y)",
          //                   dayOptions: [{ label: "Wednesday - 5:20 PM" }]
          //                 },
          //                 {
          //                   label: "Tap 1 (4y-7y)",
          //                   dayOptions: [{ label: "Tuesday - 5:15 PM" }]
          //                 },
          //                 {
          //                   label: "Tap for Adults (18+)",
          //                   dayOptions: [{ label: "Tuesday - 7:20 PM" }]
          //                 },
          //                 {
          //                   label: "Tap for Adults - 6 pack (18+)",
          //                   dayOptions: [{ label: "Tuesday - 7:20 PM" }]
          //                 }
          //               ]
          //             },
          //             {
          //               label: "Kindermusik",
          //               classOptions: [
          //                 {
          //                   label: "Foundations (0 - 1.5y)",
          //                   dayOptions: [
          //                     { label: "Monday - 5:15 PM" },
          //                     { label: "Tuesday - 9:15 AM" },
          //                     { label: "Tuesday - 11:30 AM" },
          //                     { label: "Wednesday - 11:45 AM" },
          //                     { label: "Thursday - 11:45 AM" },
          //                     { label: "Friday - 9:30 AM" },
          //                     { label: "Saturday - 11:45 AM" },
          //                     { label: "Saturday - 12:15 PM" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Level 1 (1y - 2y)",
          //                   dayOptions: [
          //                     { label: "Monday - 10:15 AM" },
          //                     { label: "Wednesday - 9:30 AM" },
          //                     { label: "Wednesday - 5:30 PM" },
          //                     { label: "Thursday - 9:15 AM" },
          //                     { label: "Thursday - 10:30 AM" },
          //                     { label: "Saturday - 9:30 AM" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Level 2 (1.5y - 3.5y)",
          //                   dayOptions: [
          //                     { label: "Monday - 9:15 AM" },
          //                     { label: "Monday - 6:15 PM" },
          //                     { label: "Tuesday - 10:15 AM" },
          //                     { label: "Wednesday - 10:30 AM" },
          //                     { label: "Wednesday - 10:45 AM" },
          //                     { label: "Thursday - 9:30 AM" },
          //                     { label: "Thursday - 10:15 AM" },
          //                     { label: "Friday - 10:30 AM" },
          //                     { label: "Saturday - 10:00 AM" },
          //                     { label: "Saturday - 10:30 AM" },
          //                     { label: "Saturday - 11:00 AM" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Level 3 (3y - 5y)",
          //                   dayOptions: [
          //                     { label: "Monday - 4:00 PM" },
          //                     { label: "Wednesday - 1:00 PM" },
          //                     { label: "Wednesday - 4:30 PM" },
          //                     { label: "Thursday - 12:00 PM" },
          //                     { label: "Friday - 11:45 AM" },
          //                     { label: "Saturday - 9:00 AM" }
          //                   ]
          //                 }
          //               ]
          //             },
          //             {
          //               label: "Music Lessons (Private)",
          //               classOptions: [
          //                 {
          //                   label: "Brass",
          //                   dayOptions: [
          //                     { label: "Duration: 30-min lesson" },
          //                     { label: "Duration: 45-min lesson" },
          //                     { label: "Duration: 60-min lesson" },
          //                     { label: "Duration: not sure" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Cello",
          //                   dayOptions: [
          //                     { label: "Duration: 30-min lesson" },
          //                     { label: "Duration: 45-min lesson" },
          //                     { label: "Duration: 60-min lesson" },
          //                     { label: "Duration: not sure" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Flute",
          //                   dayOptions: [
          //                     { label: "Duration: 30-min lesson" },
          //                     { label: "Duration: 45-min lesson" },
          //                     { label: "Duration: 60-min lesson" },
          //                     { label: "Duration: not sure" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Guitar",
          //                   dayOptions: [
          //                     { label: "Duration: 30-min lesson" },
          //                     { label: "Duration: 45-min lesson" },
          //                     { label: "Duration: 60-min lesson" },
          //                     { label: "Duration: not sure" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Piano",
          //                   dayOptions: [
          //                     { label: "Duration: 30-min lesson" },
          //                     { label: "Duration: 45-min lesson" },
          //                     { label: "Duration: 60-min lesson" },
          //                     { label: "Duration: not sure" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Violin",
          //                   dayOptions: [
          //                     { label: "Duration: 30-min lesson" },
          //                     { label: "Duration: 45-min lesson" },
          //                     { label: "Duration: 60-min lesson" },
          //                     { label: "Duration: not sure" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Voice",
          //                   dayOptions: [
          //                     { label: "Duration: 30-min lesson" },
          //                     { label: "Duration: 45-min lesson" },
          //                     { label: "Duration: 60-min lesson" },
          //                     { label: "Duration: not sure" }
          //                   ]
          //                 }
          //               ]
          //             },
          //             {
          //               label: "Music Lessons (Group)",
          //               classOptions: [
          //                 {
          //                   label: "Simply Music Piano 1",
          //                   dayOptions: [
          //                     { label: "Wednesday - 6:30 PM" },
          //                     { label: "Thursday - 4:00 PM" }
          //                   ]
          //                 },
          //                 {
          //                   label: "Simply Music Piano 2",
          //                   dayOptions: [{ label: "Thursday - 5:00 PM" }]
          //                 }
          //               ]
          //             }
          //           ],
          //           validators: {}
          //         }
          //       ]
          //     }
          //   ],
          //   autocompleteResponse: []
          // },
        //   form: {
        //     programData: [
        //       {
        //         id: "art",
        //         classOptions: [
        //           {
        //             id: "art_beginnings",
        //             label: "Art Beginnings (1.5y-3y)",
        //             dayOptions: [
        //               "Thursday - 9:45 AM",
        //               "Thursday - 10:30 AM",
        //               "Friday - 9:45 AM"
        //             ]
        //           },
        //           {
        //             id: "art_discovery_1",
        //             label: "Art Discovery 1 (3y-5y)",
        //             dayOptions: [
        //               "Wednesday - 5:30 PM",
        //               "Friday - 10:30 AM"
        //             ]
        //           },
        //           {
        //             id: "art_discovery_2",
        //             label: "Art Discovery 2 (5y-8y)",
        //             dayOptions: [
        //               "Monday - 4:00 PM",
        //               "Saturday - 10:15 AM"
        //             ]
        //           },
        //           {
        //             id: "art_discovery_3",
        //             label: "Art Discovery 3 (8y-11y)",
        //             dayOptions: [
        //               "Monday - 5:00 PM",
        //               "Saturday - 11:15 AM"
        //             ]
        //           },
        //           {
        //             id: "art_evolution_1",
        //             label: "Art Evolution 1 (11y-13y)",
        //             dayOptions: ["Monday - 6:15 PM"]
        //           }
        //         ]
        //       },
        //       {
        //         id: "dance",
        //         classOptions: [
        //           {
        //             id: "pre_ballet_lnl_3",
        //             label: "Pre-Ballet Leap N Learn 3 (3y)",
        //             dayOptions: [
        //               "Monday - 10:15 AM",
        //               "Wednesday - 3:30 PM",
        //               "Thursday - 6:15 PM",
        //               "Friday - 9:30 AM",
        //               "Saturday - 9:15 AM"
        //             ]
        //           },
        //           {
        //             id: "pre_ballet_lnl_4",
        //             label: "Pre-Ballet Leap N Learn 4 (4y)",
        //             dayOptions: [
        //               "Monday - 2:00 PM",
        //               "Wednesday - 4:30 PM",
        //               "Thursday - 5:15 PM",
        //               "Saturday - 10:15 AM"
        //             ]
        //           },
        //           {
        //             id: "pre_ballet_lnl_5",
        //             label: "Pre-Ballet Leap N Learn 5 (5y)",
        //             dayOptions: [
        //               "Tuesday - 4:15 PM",
        //               "Saturday - 11:15 AM"
        //             ]
        //           },
        //           {
        //             id: "pre_ballet_lnl_6",
        //             label: "Pre-Ballet Leap N Learn 6 (6y)",
        //             dayOptions: ["Saturday - 12:15 PM"]
        //           },
        //           {
        //             id: "pre_hiphop_1",
        //             label: "Pre Hip Hop 1 (4.5y-8y)",
        //             dayOptions: ["Wednesday - 4:30 PM"]
        //           },
        //           {
        //             id: "pre_hiphop_2",
        //             label: "Pre Hip Hop 2 (7y-10y)",
        //             dayOptions: ["Wednesday - 5:30 PM"]
        //           },
        //           {
        //             id: "jazz_1",
        //             label: "Jazz 1 (8y-10y)",
        //             dayOptions: ["Wednesday - 5:20 PM"]
        //           },
        //           {
        //             id: "tap_1",
        //             label: "Tap 1 (4y-7y)",
        //             dayOptions: ["Tuesday - 5:15 PM"]
        //           },
        //           {
        //             id: "tap_adults",
        //             label: "Tap for Adults (18+)",
        //             dayOptions: ["Tuesday - 7:20 PM"]
        //           },
        //           {
        //             id: "tap_adults_pack",
        //             label: "Tap for Adults - 6 pack (18+)",
        //             dayOptions: ["Tuesday - 7:20 PM"]
        //           }
        //         ]
        //       },
        //       {
        //         id: "kindermusik",
        //         classOptions: [
        //           {
        //             id: "foundations",
        //             label: "Foundations (0 - 1.5y)",
        //             dayOptions: [
        //               "Monday - 5:15 PM",
        //               "Tuesday - 9:15 AM",
        //               "Tuesday - 11:30 AM",
        //               "Wednesday - 11:45 AM",
        //               "Thursday - 11:45 AM",
        //               "Friday - 9:30 AM",
        //               "Saturday - 11:45 AM",
        //               "Saturday - 12:15 PM"
        //             ]
        //           },
        //           {
        //             id: "level_1",
        //             label: "Level 1 (1y - 2y)",
        //             dayOptions: [
        //               "Monday - 10:15 AM",
        //               "Wednesday - 9:30 AM",
        //               "Wednesday - 5:30 PM",
        //               "Thursday - 9:15 AM",
        //               "Thursday - 10:30 AM",
        //               "Saturday - 9:30 AM"
        //             ]
        //           },
        //           {
        //             id: "level_2",
        //             label: "Level 2 (1.5y - 3.5y)",
        //             dayOptions: [
        //               "Monday - 9:15 AM",
        //               "Monday - 6:15 PM",
        //               "Tuesday - 10:15 AM",
        //               "Wednesday - 10:30 AM",
        //               "Wednesday - 10:45 AM",
        //               "Thursday - 9:30 AM",
        //               "Thursday - 10:15 AM",
        //               "Friday - 10:30 AM",
        //               "Saturday - 10:00 AM",
        //               "Saturday - 10:30 AM",
        //               "Saturday - 11:00 AM"
        //             ]
        //           },
        //           {
        //             id: "level_3",
        //             label: "Level 3 (3y - 5y)",
        //             dayOptions: [
        //               "Monday - 4:00 PM",
        //               "Wednesday - 1:00 PM",
        //               "Wednesday - 4:30 PM",
        //               "Thursday - 12:00 PM",
        //               "Friday - 11:45 AM",
        //               "Saturday - 9:00 AM"
        //             ]
        //           }
        //         ]
        //       },
        //       {
        //         id: "music_private",
        //         classOptions: [
        //           {
        //             id: "brass",
        //             label: "Brass",
        //             dayOptions: [
        //               "Duration: 30-min lesson",
        //               "Duration: 45-min lesson",
        //               "Duration: 60-min lesson",
        //               "Duration: not sure"
        //             ]
        //           },
        //           {
        //             id: "cello",
        //             label: "Cello",
        //             dayOptions: [
        //               "Duration: 30-min lesson",
        //               "Duration: 45-min lesson",
        //               "Duration: 60-min lesson",
        //               "Duration: not sure"
        //             ]
        //           },
        //           {
        //             id: "flute",
        //             label: "Flute",
        //             dayOptions: [
        //               "Duration: 30-min lesson",
        //               "Duration: 45-min lesson",
        //               "Duration: 60-min lesson",
        //               "Duration: not sure"
        //             ]
        //           },
        //           {
        //             id: "guitar",
        //             label: "Guitar",
        //             dayOptions: [
        //               "Duration: 30-min lesson",
        //               "Duration: 45-min lesson",
        //               "Duration: 60-min lesson",
        //               "Duration: not sure"
        //             ]
        //           },
        //           {
        //             label: "Piano",
        //             dayOptions: [
        //               "Duration: 30-min lesson",
        //               "Duration: 45-min lesson",
        //               "Duration: 60-min lesson",
        //               "Duration: not sure"
        //             ]
        //           },
        //           {
        //             id: "violin",
        //             label: "Violin",
        //             dayOptions: [
        //               "Duration: 30-min lesson",
        //               "Duration: 45-min lesson",
        //               "Duration: 60-min lesson",
        //               "Duration: not sure"
        //             ]
        //           },
        //           {
        //             id: "voice",
        //             label: "Voice",
        //             dayOptions: [
        //               "Duration: 30-min lesson",
        //               "Duration: 45-min lesson",
        //               "Duration: 60-min lesson",
        //               "Duration: not sure"
        //             ]
        //           }
        //         ]
        //       },
        //       {
        //         id: "music_group",
        //         classOptions: [
        //           {
        //             id: "simply_music_1",
        //             label: "Simply Music Piano 1",
        //             dayOptions: [
        //               "Wednesday - 6:30 PM",
        //               "Thursday - 4:00 PM"
        //             ]
        //           },
        //           {
        //             id: "simply_music_2",
        //             label: "Simply Music Piano 2",
        //             dayOptions: ["Thursday - 5:00 PM"]
        //           }
        //         ]
        //       }
        //     ]
        //   }
        // }
      ]
    },
    contact_page: {
      sections: [
        {
          id: "contact",
          text:
            "<div class='contact'><div>Thanks for stopping by! Let's keep in touch.</div>",
          icons: [
            {
              name: "email",
              url: "mailto:sara.huser@gmail.com"
            },
            {
              name: "linkedin",
              url: "https://www.linkedin.com/in/sara-huser-a9a89648"
            },
            {
              name: "instagram",
              url: "https://www.instagram.com/sara_huser/"
            },
            {
              name: "github",
              url: "https://github.com/sara-huser"
            },
            // {
            //   name: 'behance',
            //   url: ''
            // },
            {
              name: "pinterest",
              url: "https://www.pinterest.com/huser0280/"
            }
            // {
            //   name: 'codepen',
            //   url: ''
            // }
          ]
        }
      ]
    }
  },
  mutations: {},
  actions: {},
  getters: {
    getProjectByUrl: state => url => {
      return state.work_page.projects.find(project => project.url === url);
    }
  }
});
